module.exports = __webpack_public_path__ + "img/ic_32_profile_other.efb27aff.svg";